import { render, staticRenderFns } from "./PriceCompareBar.vue?vue&type=template&id=b86815f8&scoped=true&"
import script from "./PriceCompareBar.vue?vue&type=script&lang=js&"
export * from "./PriceCompareBar.vue?vue&type=script&lang=js&"
import style0 from "./PriceCompareBar.vue?vue&type=style&index=0&id=b86815f8&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b86815f8",
  null
  
)

export default component.exports